import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 64,
  label: "发明人技术分类分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "miniIpc", label: "主分类小类", limit: 10, needTotal: true }],
    colDims: [{
      name: "inventorNewName",
      label: "发明人",
      table: "patent_inventor",
      limit: 10,
      needTotal: true
    }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "发明人技术分类分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false
  }
};
